var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm.fileList.length > 0
        ? _c(
            "div",
            { staticClass: "flex-box" },
            _vm._l(_vm.newFileList, function(item, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.type !== 8,
                      expression: "item.type!==8"
                    }
                  ],
                  key: index + "a",
                  staticClass: "file-item"
                },
                [
                  _c("img", { attrs: { src: item.fileImg, alt: "" } }),
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(item.name))
                  ]),
                  _c(
                    "div",
                    { staticClass: "action" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.openFile(item.path, item.suffix, index)
                            }
                          }
                        },
                        [_vm._v("查看")]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _c("Empty", { attrs: { text: "暂无材料" } }),
      _c("ImageDialog", { ref: "imageDialog" }),
      _c("VideoPlayer", { ref: "videoPlayer" }),
      _c(
        "viewer",
        {
          ref: "viewer",
          staticClass: "viewer",
          attrs: { images: _vm.imagesList },
          on: { inited: _vm.inited }
        },
        _vm._l(_vm.imagesList, function(item, index) {
          return _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            key: index,
            attrs: { src: item }
          })
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }